import api from "../api/api"; // correct relative path to your configured axios instance

export const fetchInterviewTimeline = async (interviewId) => {
  try {
    const res = await api.get(`/interviews/${interviewId}/timeline`);
    return res.data.timeline;
  } catch (error) {
    console.error("❌ Error fetching timeline:", error);
    return [];
  }
};
